import React from "react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import BlockRoundedIcon from "@mui/icons-material/BlockRounded";

// Incoming-call classification options shared across address book + entry forms.
// "safe" has no badge/icon in lists; only "warn" and "unsafe" are surfaced.
export const CLASSIFICATIONS = [
    { value: "safe", label: "Safe", color: "#15803d", bg: "#dcfce7", Icon: null },
    { value: "warn", label: "Warn", color: "#b45309", bg: "#fef3c7", Icon: WarningAmberRoundedIcon },
    { value: "unsafe", label: "Unsafe", color: "#b91c1c", bg: "#fee2e2", Icon: BlockRoundedIcon },
];

export function classificationMeta(value) {
    return CLASSIFICATIONS.find((c) => c.value === value) || CLASSIFICATIONS[0];
}

/** Small coloured pill (icon + label) showing a classification value. */
export function ClassificationBadge({ value, size = "sm" }) {
    const m = classificationMeta(value);
    const pad = size === "sm" ? "2px 8px" : "4px 10px";
    const fs = size === "sm" ? 11 : 12;
    const Icon = m.Icon;
    return (
        <span style={{
            display: "inline-flex", alignItems: "center", gap: 4,
            fontSize: fs, fontWeight: 600, color: m.color,
            background: m.bg, borderRadius: 20, padding: pad,
        }}>
            {Icon && <Icon sx={{ fontSize: fs + 3 }} />}
            {m.label}
        </span>
    );
}

/** Dropdown select for classification — short labels only. */
function ClassificationSelect({ value, onChange, disabled, label = "Classification" }) {
    return (
        <div>
            {label && (
                <label style={{ fontSize: 13, fontWeight: 600, color: "#444", display: "block", marginBottom: 6 }}>
                    {label}
                </label>
            )}
            <select
                value={value || "safe"}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                style={{
                    width: "100%", padding: "10px 14px",
                    border: "1.5px solid #e0e0e0", borderRadius: 8,
                    fontSize: 14, outline: "none", boxSizing: "border-box",
                    background: "#fff", color: "#1a1a2e", cursor: "pointer",
                }}
            >
                {CLASSIFICATIONS.map((c) => (
                    <option key={c.value} value={c.value}>
                        {c.label}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default ClassificationSelect;
